@if (isLoading$ | async) {
  <nrc-loading
    class="fixed z-50 w-full h-full bg-white/25"
  />
}

@if (toastMessage()) {
  <nrc-toast
    @fadeInOutAnimation
    class="fixed z-50 bottom-10 right-10"
    [toastMessage]="toastMessage()"
  />
}

@if (alertMessage()) {
  <nrc-alert
    @fadeInOutAnimation
    [message]="alertMessage()"
    [confirmButton]="{ label: 'Ok' }"
    (confirmEvent)="alertService.resetMessage()"
  />
}

@if (showLogo()) {
  <img
    class="fixed top-0 left-0 z-10 w-16 mt-8 ml-8"
    src="assets/images/nrc_logo_white.svg"
    alt="NRC Logo"
    draggable="false"
  />
}

@if (fileProcessingService.processingProgress | async) {
  <nrc-file-processing-status class="fixed z-[105] bottom-5 right-4 min-w-80"/>
}
<ng-container #modalContainer></ng-container>

<div class="flex flex-col items-center justify-center w-full h-full overflow-y-auto">
  <div class="flex flex-col w-full h-full overflow-hidden grow">
    <router-outlet></router-outlet>

    <nrc-footer
      [currentProjectSlug]="currentProjectSlug()"
      [pages]="currentProject()?.footerPages ?? []"
      [appVersion]="appVersion"
      [isProdEnvironment]="isProdEnvironment"
      [imprintLabel]="'APP_FOOTER.LINKS.IMPRINT' | translate"
      [privacyLabel]="'APP_FOOTER.LINKS.PRIVACY' | translate"
    />
  </div>
</div>
